

































































import _ from "lodash";
import "devextreme/dist/css/dx.light.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Maintenancejob, Property } from "@/models";
import DatesTab from '@/pages/jobs/tabs/Dates.vue';
import { DxDateBox } from "devextreme-vue/date-box";

@Component({
  components: {
    DatesTab,
    DxDateBox
  }
})
export default class Dates extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("maintenancejobs/hasUnsavedChanges")
  public hasUnsavedChanges: boolean;

  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Getter("maintenancejob/list") public list: Property[];

  @Getter("maintenancejobs/list") public maintenancejoblist: Maintenancejob[];

  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;

  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  public clearStatus() {
    this.setMaintenancejobDeep({ path: "status", data: "" });
  }

  public setStatus(val: string) {
    this.setMaintenancejobDeep({ path: "status", data: val });
  }

  get status() {
    return this.maintenancejob.status;
  }
  set status(data) {
    this.setMaintenancejobDeep({ path: "status", data });
  }

  get completiondate() {
    return this.maintenancejob.completiondate;
  }
  set completiondate(data) {
    this.setMaintenancejobDeep({ path: "completiondate", data });
  }

  get createdate() {
    return this.maintenancejob.createdate;
  }
  set createdate(data) {
    this.setMaintenancejobDeep({ path: "createdate", data });
  }

  get targetdate() {
    return this.maintenancejob.targetdate;
  }
  set targetdate(data) {
    this.setMaintenancejobDeep({ path: "targetdate", data });
  }

  get addressLine1() {
    return this.maintenancejob.address.line1;
  }
  set addressLine1(data) {
    this.setMaintenancejobDeep({ path: "address.line1", data });
  }

  
  public statusOptions: string[] = [
    "New",
    "Unallocated",
    "Allocated",
    "In Progress",
    "On Hold",
    "Completed"
  ];
  
}
